<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ this.$route.query.id != null ? 'Edit' : 'Add' }} Expected Salary</h1>
    </div>
    <div class="row">
      <div class="col-12 mt-4">
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Name</label>
            <input class="form-control col-lg-8" id="form-name" v-model="name"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Minimum Salary</label>
            <input class="form-control col-lg-8" id="form-name" v-model="min_salary"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Maximum Salary</label>
            <input class="form-control col-lg-8" id="form-name" v-model="max_salary"/>
          </div>
        </div>
        <div class="form-group text-right">
          <a type="button" class="btn btn-danger" href="/master/expected-salary">Cancel</a>
          <button type="button" class="btn btn-primary" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Base from '@/utils/base'
import please_wait_modal from '@/layout/please_wait_modal'
import modal_edit from '@/pages/master/helper_sub_category/modal_edit_sub_sub_category'

export default {
  components:{
    'please-wait-modal': please_wait_modal,
    'modal-edit': modal_edit,
  },
  data(){
    return{
      base: null,
      name: '',
      min_salary: '0',
      max_salary: '0',
    }
  },
  watch:{
    min_salary(val){
      this.min_salary = this.base.to_currency_format(val)
    },
    max_salary(val){
      this.max_salary = this.base.to_currency_format(val)
    },
  },
  async created(){
    this.base = new Base()
    
    if(this.$route.query.id != null){
      await this.get_data()
    }
  },
  methods:{
    async save(){
      try{
        if(this.name == '')
          this.$toasted.show('Name is empty')
        else if(this.min_salary == '0' && this.max_salary == '0')
          this.$toasted.show('Either Minimum Salary or Maximum Salary')
        else{
          $('#please_wait_modal').modal('show')
          var data = {
            name: this.name,
            min_salary: this.base.str_to_double(this.min_salary),
            max_salary: this.base.str_to_double(this.max_salary),
          }
          if(this.$route.query.id != null)
            data.id = this.$route.query.id

          if(this.$route.query.id == null)
            var response = await axios.post(base_url+'/expected-salary',data)
          else
            var response = await axios.put(base_url+'/expected-salary',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = '/master/expected-salary'
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    async get_data(){
      try{
        var response = await axios.get(base_url + '/expected-salary?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.name = response_data.data.name
          this.min_salary = parseFloat(response_data.data.min_salary).toLocaleString(this.base.locale_string)
          this.max_salary = parseFloat(response_data.data.max_salary).toLocaleString(this.base.locale_string)
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
  }
}
</script>
